export default __webpack_public_path__ + "static/media/11.0de76cb8.png";